import { render, staticRenderFns } from "./SectionHeading.vue?vue&type=template&id=6ffa8674&scoped=true&"
import script from "./SectionHeading.vue?vue&type=script&lang=js&"
export * from "./SectionHeading.vue?vue&type=script&lang=js&"
import style0 from "./SectionHeading.vue?vue&type=style&index=0&id=6ffa8674&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffa8674",
  null
  
)

export default component.exports